import displayFlash from "partners/scripts/display_flash"

import * as $ from "jquery"

export default function readonlySelect() {
  $("body").on(
    "click",
    "input[data-copy-field-on-click], textarea[data-copy-field-on-click]",
    event => {
      const message = $(event.target).data("copy-field-on-click")
      event.target.select()
      navigator.clipboard.writeText(event.target.value)
      document.getSelection().removeAllRanges()
      displayFlash(`Your ${message} has been copied to clipboard`)
    }
  )
}
